
import { useRefundTracked } from "presentation/store/Refund/RefundProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import RefundOperationPanel from "./RefundOperationPanel";
import RefundTablePanel from "./RefundTablePanel";

export const RefundRightPanel: React.FC = () => {
    const [refundState] = useRefundTracked();
    const { isShowOperationPanel } = refundState;

    return <>
        <div className={`main-comp-wrapper${(isShowOperationPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowOperationPanel ? '70%' : '100%'}
                rightSectionWidth={isShowOperationPanel ? "30%" : '0%'}
                leftChildren={<RefundTablePanel />}
                rightChildren={<RefundOperationPanel />}
            />
        </div>
    </>
}